<div class="chat-bubble-container">
  <img src="assets/images/{{environment.chatLogo}}" alt="Thumbnail" class="chat-thumbnail">
  <div class="chat-bubble">
    @if ( (message.messageStatus == MessageStatus.MESSAGE_FINALIZED || message.messageStatus == MessageStatus.TOOL_EXECUTION_PENDING) && message.userChoice != "USER_CANCEL" && message.tooling.status!="TOOL_ERROR"){
      <i
        class="bi bi-info-circle position-absolute bottom-0 end-0 m-2"
        style="cursor: pointer; font-size: 1.2rem;"
        title="{{ 'tools.checkTool' | translate }}"
        (click)="jumpToTool(message.userChoice, message.tooling.toolingId)">
      </i>
    }
    @if ((environment.autoSilentPlanner && message.tooling.tool==ToolingType.PLANNER_AGENT) || (environment.autoSilentRag && message.tooling.tool==ToolingType.RAG_AGENT)) {
      <span   class= "bg-info badge ms-auto">{{ 'general.autoSilent' | translate }}</span>
    }
    @if (message.rawData) {
      <markdown >{{ message.rawData }}</markdown><br/>
    }
    @else {
      @if ( message.messageStatus == MessageStatus.MESSAGE_FINALIZED){
        <p>Tool response:</p>
        <markdown>{{ message.tooling.rawData }} </markdown><br/>
      }
      @else {
        <p>{{ 'chat.noRawData' | translate }} </p>
      }
    }
    @if ( (message.messageStatus != MessageStatus.MESSAGE_FINALIZED && message.messageStatus != MessageStatus.TOOL_EXECUTION_PENDING && message.messageStatus != MessageStatus.USER_CHOICE_FINALIZED)){
    <div class="buttonContainer d-flex flex-wrap" >
      <button class="btn btn-outline-dark mt-2 me-2 d-inline-block" *ngFor="let tool of message.availableUserChoices"
              (click)="toolSelector(tool,message.messageId)">{{ 'tools.' + tool | translate }}
      </button>
    </div>
    }
  </div>
</div>
